export const getCompanyVerifyLicenseInitState = {
	data: null,
	error: null,
	errorShow: false,
	loading: false,
};
